import { SET_KEYS } from './actions';

const initialState = {
  role: '',
  company: {},
  // The server's module catalog (GET /company-session/:slug `moduleCatalog`):
  // upgrade copy for every module gate. Kept beside the company, never inside
  // it — ten settings screens replace `company` wholesale with a PUT response.
  moduleCatalog: null,
  jwt: '',
};

export default function Reducer(state = initialState, action) {
  const { type, data } = action;
  switch (type) {
    case SET_KEYS:
      return {
        ...state,
        ...data,
      };
    default:
      return state;
  }
}
